module.exports = __webpack_public_path__ + "img/group.6bded1e1.png";